import { render, staticRenderFns } from "./AmonestacionesReportForMes.vue?vue&type=template&id=7c077a17&"
import script from "./AmonestacionesReportForMes.vue?vue&type=script&lang=js&"
export * from "./AmonestacionesReportForMes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports